module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-14.f4efbc0f.png";